import axios from 'axios';
import { storeAction } from "../storeActions.constant";
import { getBasicHeaders } from "../../common/utils/utils";
import { wrapAction } from "../../common/utils/actionLifecycle";
import { storeMutation } from "../storeMutations.constant";
import { storeGetters } from "../storeGetters.constant";
import orderBy from "lodash/orderBy";

const eventAttendeesState = () => {
    return {
        baseURL: process.env.VUE_APP_BASE_URL,
        whoIsComing: [],
        infiniteScrollBusy: false,
        infiniteScrollLimit: 5,
    };
};
const eventAttendeesActions = {
    [storeAction.getEventAttendees]: wrapAction(
        storeAction.getEventAttendees,
        ({ state, commit }, eventId) => {
            commit(storeMutation.resetEventAttendees);
            return axios({
                url: `${state.baseURL}events/api/events/getUsersAttendingEvent/${eventId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            }).then((res) => {
                commit(storeMutation.setEventAttendees, res.data);
                return res;
            }).catch((err) => {
                console.log(err);
                throw err;
            });
        },
    ),
};

const eventAttendeesMutations = {
    [storeMutation.setEventAttendees]: (state, data) => {
        const unSorted = data.map((o) => {
            return { ...o, displayName: `${o.lastName}, ${o.firstName}` };
        });
        state.whoIsComing = orderBy(unSorted, ['displayName'], ['asc']);
    },
    [storeMutation.resetEventAttendees]: (state) => {
        state.whoIsComing = [];
    },
};

const eventAttendeesGetters = {
    [storeGetters.eventAttendees]: state => state.whoIsComing,
};

export default {
    namespaced: true,
    state: {
        initialState: eventAttendeesState(),
        ...eventAttendeesState(),
    },
    mutations: { ...eventAttendeesMutations },
    actions: { ...eventAttendeesActions },
    getters: { ...eventAttendeesGetters },
};
